import * as React from "react"

import Suggestion from "./Suggestion"

interface OwnProps {
    focusedSuggestionCode: string | null
    onSuggestionClick: (selectedSuggestion: Search.Suggestion) => void
    suggestions: Search.Suggestion[]
}

export const SuggestionList = ({
    focusedSuggestionCode,
    onSuggestionClick,
    suggestions,
}: OwnProps): JSX.Element => (
    <>
        {suggestions.map((suggestion, index) => (
            <Suggestion
                highlighted={suggestion.normalized === focusedSuggestionCode}
                suggestion={suggestion}
                key={index}
                onSuggestionClick={onSuggestionClick}
            />
        ))}
    </>
)
